// The reducer is a pure function that takes the previous state and an action,
// and returns the next state.

// For now, just remember that the reducer must be pure.
// Given the same arguments, it should calculate the next state and return it.
// No surprises. No side effects. No API calls. No mutations. Just a calculation
// { ...state, ...newState }
// https://stackoverflow.com/questions/46761718/update-nested-object-using-object-assign

// import { setImportProgress, setImportTotal } from '../actions/ui-actions';

const ui = (
	state = {
		currentPanel: false,
		messages: false,
		importProgress: {
			importing: false,
			total: 0,
			imported: 0,
		},
	}, action ) => {
	switch ( action.type ) {
		case 'IMPORT_PROGRESS_STATUS_SET':
			return {
				...state,
				importProgress: {
					...state.importProgress,
					importing: action.status,
				},
			};

		case 'IMPORT_PROGRESS_SET':
			if ( state.importProgress.total > 0 ) {
				return {
					...state,
					importProgress: {
						...state.importProgress,
						imported: Math.trunc( state.importProgress.imported + ( action.imported / state.importProgress.total * 100 ) ),
					},
				};
			}
			return {
				...state,
				importProgress: {
					...state.importProgress,
					imported: 0,
				},
			};

		case 'IMPORT_PROGRESS_TOTAL_SET':
			if ( action.total > state.importProgress.total || action.total === 0 ) {
				return {
					...state,
					importProgress: {
						...state.importProgress,
						total: action.total,
					},
				};
			}
			return state;

		case 'CURRENT_PANEL_SET':
			return {
				...state,
				currentPanel: action.newId,
			};

		default:
			return state;
	}
};

export default ui;



// WEBPACK FOOTER //
// ./src/reducers/ui.js